export function introContext(item: any, request: any, fallbackQuery = '', source = 'results_card') {
  return {
    company: String(item?.unit?.entityName || item?.entityName || item?.companyName || ''),
    query: String(item?.originalQuery || request?.originalContent || request?.simplifiedDemands?.[0]?.originalQuery || request?.demands?.[0]?.description || item?.query || item?.queryText || fallbackQuery || ''),
    source,
    matchRequestId: String(request?.id || ''),
    clickedUnitId: Number(item?.unit?.id || item?.unitId) || null
  }
}
export function publicIntro(trackId: unknown, paid: unknown): boolean {
  return String(trackId ?? '0') === '0' && paid !== true
}
export function introButtonText(mobile: boolean): string {
  return 'Ask Namecard for the Intro'
}
export function resultsRendered(trackId: unknown, count: number): void {
  if (String(trackId ?? '0') !== '0') return
  const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '')
  fetch(base + '/api/public/events', { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event_name: 'results_rendered', source: 'results', props: { len: count } }) }).catch(() => undefined)
}
